import { apiClient } from '@/core/apiClient';

export interface CitiesSearchParams {
  q?: string;
  limit?: number;
  skip?: number;
}

export const citiesApi = {
  listFirst: async (limit = 5000) => {
    const params: Record<string, any> = {
      'filter[limit]': limit,
      'filter[order][0]': 'department ASC',
      'filter[order][1]': 'name ASC',
    };
    const res = await apiClient.get('/cities', { params });
    return res.data;
  },
  search: async ({ q = '', limit = 20, skip = 0 }: CitiesSearchParams) => {
    const params: Record<string, any> = {
      'filter[limit]': limit,
      'filter[skip]': skip,
      'filter[order][0]': 'department ASC',
      'filter[order][1]': 'name ASC',
    };
    if (q) {
      params['filter[where][or][0][name][like]'] = `%${q}%`;
      params['filter[where][or][1][department][like]'] = `%${q}%`;
    }
    const res = await apiClient.get('/cities', { params });
    return res.data;
  },
};
